import {
    getConfirmOrderData,
    getNetworkProvider,
    getPaymentMode,
    getPhoneNumber,
    getUgStkRequestId,
} from '../../../selectors/ugMotorInsurance/payments';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { setBankDetailsSuccess, setUgStkRequestId } from '../../../actions/ugMotorInsurance/payments';
import { orderConfirmationService } from './orderConfirmation';
import {
    getCustomerIdValue,
    getInsuranceQuotationIdValue,
    getPremiumCalculationUg,
} from '../../../selectors/ugMotorInsurance/quote';
import { submitBankPaymentDetailsService } from './submitBankPaymentData';

export const submitPaymentDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                let state = store.getState();

                const modeOfPayment = getPaymentMode(state);

                if (modeOfPayment === 'Flexipay') {
                    const requestId = getUgStkRequestId(state);

                    const transactionRef = requestId || 'N/A';

                    const orderData = getConfirmOrderData(state);

                    if (transactionRef !== 'N/A' && !orderData?.base64) {
                        store.dispatch(setBankDetailsSuccess(false));
                        orderConfirmationService(store, next, action);
                    }
                } else if (modeOfPayment === 'Bank') {
                    store.dispatch(apiTransitionPayloadCollection.initial());
                    submitBankPaymentDetailsService(store, next, action);
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

const payloadCollection = (store, state) => {
    const paymentMode = getPaymentMode(state);

    const phoneNumber = getPhoneNumber(state);
    const networkProvider = getNetworkProvider(state);

    const msisdn = formatPhoneNumber(phoneNumber.value, '256');

    const customerId = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const premium = getPremiumCalculationUg(state);
    const requestId = getCurrentTimestamp();

    store.dispatch(setUgStkRequestId(requestId));

    const paymentPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        transactionRef: requestId,
        modeOfPayment: paymentMode.toUpperCase().trim(),
        //stk data
        msisdn: msisdn,
        //in dev: amount: '500' || in prod: premium.value.premium.toString(),
        amount: premium.value.premium.toString(),
        sourceSystem: networkProvider.value || '',
        narrative: 'UG Motor Insurance',
        requestId,
        referenceNumber: requestId,
    };

    return {
        ...paymentPayload,
    };
};

export const makePaymentSubmission = async (store, state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/payment';
        return await axios.post(url, payloadCollection(store, state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
